<template>
  <div class="mt-30 w-full md:mt-37.5 xl:mt-42.5! 2xl:mt-47.5!">
    <component
      :is="currentComponent?.component"
      v-bind="currentComponent?.props"
    />
  </div>
</template>

<script setup lang="ts">
import {
  LazyDepartmentPage,
  LazyEmployeePage,
  LazyEventDetailPage,
  LazyEventsPage,
  LazyNodePage,
  LazyNoticesPage,
  LazyPublicationDetailPage,
  LazyPublicationsPage,
  LazySchedulePage,
} from '#components'

definePageMeta({
  key: (route) => route.path,
})

const { throwFetchError, throwNotFound } = useThrowErrors()
const route = useRoute()

const isPreview = computed(() => {
  const p = route.query.preview
  return p === '1' || p === 'true'
})

const { data, pending, error } = await usePersistedFetch('GetPageBySlug', {
  slug: route.path.replace('/en', ''),
  preview: () => isPreview.value,
})

const page = computed(() => data.value?.getPageBySlug)

watchEffect(() => {
  if (error.value) {
    throwFetchError()
    return
  }

  // Don't throw while still loading
  if (pending.value) return

  if (!page.value) {
    throwNotFound()
    return
  }

  if (page.value.is_published === false && !isPreview.value) {
    throwNotFound()
    return
  }
})

const currentComponent = computed(() => {
  if (page.value?.__typename?.toLowerCase() === 'programcategory')
    return { component: LazySchedulePage, props: { pageData: page.value } }

  if (page.value?.__typename?.toLowerCase() === 'menunode')
    return {
      component: LazyNodePage,
      props: { pageData: page.value },
    }
  if (page.value?.__typename?.toLowerCase() === 'department')
    return { component: LazyDepartmentPage, props: { pageData: page.value } }
  if (page.value?.__typename?.toLowerCase() === 'event')
    return {
      component: LazyEventDetailPage,
      props: {
        type: page.value.__typename?.toLowerCase(),
        pageData: page.value,
      },
    }
  if (page.value?.__typename?.toLowerCase() === 'announcement')
    return {
      component: LazyEventDetailPage,
      props: {
        type: page.value.__typename?.toLowerCase(),
        pageData: page.value,
      },
    }
  if (page.value?.__typename?.toLowerCase() === 'person')
    return {
      component: LazyEmployeePage,
    }
  if (page.value?.__typename?.toLowerCase() === 'publication')
    return {
      component: LazyPublicationDetailPage,
      props: { pageData: page.value },
    }
  if (page.value?.__typename?.toLowerCase() === 'program')
    return {
      component: LazyEventDetailPage,
      props: {
        type: page.value.__typename?.toLowerCase(),
        pageData: page.value,
      },
    }
  if (page.value?.__typename?.toLowerCase() === 'page')
    return {
      component: LazyEventDetailPage,
      props: {
        type: page.value.__typename?.toLowerCase(),
        pageData: page.value,
      },
    }

  if (page.value.__typename?.toLowerCase() === 'eventcategory')
    return { component: LazyEventsPage, props: { pageData: page.value } }
  if (page.value.__typename?.toLowerCase() === 'announcementcategory')
    return { component: LazyNoticesPage, props: { pageData: page.value } }
  if (page.value.__typename?.toLowerCase() === 'publicationcategory')
    return { component: LazyPublicationsPage, props: { pageData: page.value } }

  return null
})
</script>
